import { __awaiter } from "tslib";
import { useAemConfig } from '@as-react/common-components';
import { basketMutations } from '@as-react/common-queries';
import { usePaymentState } from '../context/CheckoutPaymentContext';
import { EventEnum } from '@as-react/common-types';
import { EventUtil } from '@as-react/common-utils';
import { useMutation } from '@tanstack/react-query';
import { useSelectPaymentOption } from './useSelectPaymentOption';
// should only be used inside PaymentContext
export const useOnVoucherChanges = () => {
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const [{ isSetPaymentGroupSuccess, selectedPaymentGroup }] = usePaymentState();
    const { selectPaymentGroup } = useSelectPaymentOption();
    const { postSavePoint } = basketMutations({ servicesEndpoint, defaultRequestParams });
    const { mutateAsync: mutatePostSavePoint } = useMutation(postSavePoint);
    const onVoucherChanges = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (isSetPaymentGroupSuccess) {
                if (selectedPaymentGroup) {
                    yield selectPaymentGroup(selectedPaymentGroup);
                }
            }
            else {
                yield mutatePostSavePoint();
            }
        }
        catch (_a) { }
        EventUtil.dispatch(EventEnum.VOUCHER_CHANGED, true);
    });
    return { onVoucherChanges };
};
